import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { MedicalComponentService, ValueSetHttpService } from 'shared/domain';
import { ShortType } from 'shared/util-common';

import { Components, ComponentType } from '@treetop/shared/model';

import { codeUtil, getTTCodeFromTitle } from './code.util';
import { FormFieldImports } from '../form-field';
import { InputDirective } from '../input/input.directive';
import { LabelDirective } from '../label';

@Component({
  selector: 'tt-tree-top-code-input',
  standalone: true,
  templateUrl: './tree-top-code-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormFieldImports, LabelDirective, ReactiveFormsModule, TranslocoPipe, InputDirective],
})
export class TreeTopCodeInputComponent implements OnInit {
  public medicalComponentService = inject(MedicalComponentService);
  public valueSetService = inject(ValueSetHttpService);

  @Input() public code: FormControl<string>;
  @Input() public parentCode?: string;
  @Input() public type: ComponentType | 'Guideline';
  @Input() public hintKey: string;

  @Input() public set guidelineTitle(value: string) {
    this.handleTitleChanged(value);

    if (this.initialTitleChange) {
      this.initialTitleChange = false;

      this.followTitle = true;
    }
  }

  private followTitle = false;
  private initialTitleChange = true;

  public ngOnInit(): void {
    const code = this.code.value;

    const tmpType: string = (Components[this.type] as string) ? (Components[this.type] as string) : (this.type as string);
    if (!code) {
      const baseCode: string = ShortType[tmpType] as string;
      if (this.parentCode) {
        const separator = 'VS-';
        const parts = this.parentCode.split(separator);
        const secondPart = parts[1];
        this.code.setValue(`${baseCode}-${secondPart}-`);
      } else {
        this.code.setValue(`${baseCode}-`);
      }
    }

    if (!code.startsWith('PC')) {
      this.code.addAsyncValidators(codeUtil(this.medicalComponentService, this.valueSetService, this.type as ComponentType));
    }

    this.code.valueChanges.subscribe((value) => {
      this.code.markAsTouched();

      if (value === '') {
        this.followTitle = true;
      }
    });
  }

  private handleTitleChanged(title: string) {
    if (!this.code || !this.followTitle || this.code.disabled || this.initialTitleChange) {
      return;
    }

    this.code.setValue(getTTCodeFromTitle(title));
  }

  protected handleInput() {
    this.followTitle = this.code.value === '';
  }
}
